import styled from "styled-components";

import { ThemeProp } from "styles/theme";
import { alphalize } from "utils/colors";

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  // overflow: hidden;

  .ant-divider-horizontal.ant-divider-with-text-center::before,
  .ant-divider-horizontal.ant-divider-with-text-center::after {
    border-top: 1px solid
      ${({ theme }: ThemeProp) => alphalize(theme.textInLight, 0.2)};
  }
`;
